export const parseAsBoolean = value => {
    if (value == null) return null

    switch (value) {
        case true:
        case 'true':
        case 1:
        case '1':
        case 'on':
        case 'yes':
            return true
        default:
            return false
    }
}

export const parseAsNumber = value => {
    if (value == null) return null
    return parseInt(value, 10)
}
